import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import CommonTranslations from './CommonTranslations.json';
import CalendarTranslations from './CalendarTranslations.json';
import { Language } from '../Constants/Language';

// translation catalog
const resources = {
	[Language.fi]: {
		common: CommonTranslations.finnish,
		calendar: CalendarTranslations.finnish
	},
	[Language.en]: {
		common: CommonTranslations.english,
		calendar: CalendarTranslations.english
	},
	[Language.swe]: {
		common: CommonTranslations.swedish,
		calendar: CalendarTranslations.swedish
	}
};

const options = {
	resources,
	fallbackLng: Language.fi.toString(),
	debug: process.env.NODE_ENV === 'development',
	interpolation: {
		escapeValue: false // not needed for react as it escapes by default
	},
	detection: {
		order: ['cookie'],
		lookupCookie: 'LanguageCookie',
		caches: ['localStorage', 'cookie']
	}
};

// for passing in lng and translations on init
i18n.use(LanguageDetector).use(initReactI18next).init(options);

export default i18n;
export { i18n };
